module.exports = __webpack_public_path__ + "static/img/climateZonesMap.7fb3985.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/climateZonesMap.gif
// module id = +CWT
// module chunks = 0